module.exports = __webpack_public_path__ + "static/media/DSCF1298-1-2.f49ece3f.jpg";